<div class="inline-png-checkbox d-flex h-100">
  <!-- <input type="checkbox" name="" value="" checked> -->
  <p-checkbox [(ngModel)]="params.value" (onChange)="onClick()" [binary]="true"></p-checkbox>
</div>
